<template>
  <div class="eg-card">
    <div
      v-if="label || onboardingKey"
      class="d-flex align-items-center justify-content-between"
    >
      <div class="d-flex align-items-center">
        <div v-if="label" class="heading-s mr-1">{{ label }}</div>
        <eg-button
          v-if="onboardingKey"
          type="ordinary"
          icon="information"
          color="var(--color-icon-neutral-neutral)"
          icon-size="small"
          size="extra-small"
          @click="$eventBus.$emit(onboardingKey)"
        />
      </div>

      <slot name="extra-actions" />
    </div>

    <slot />
  </div>
</template>

<script>
export default {
  name: "EgCard",
  props: {
    label: {
      type: String,
      default: "",
    },

    onboardingKey: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped lang="scss">
.eg-card {
  gap: 24px;
  padding: 24px;
  background-color: var(--color-surface-neutral-card-background);
  border-radius: 12px;
  box-shadow: 3px 3px 20px 0px #0000000a;
  font-family: Inter;
}
</style>
